import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from "../pages/login/login";
import { DataProvider } from '../providers/data/data';
import { HomePage } from '../pages/home/home';
import { CowRegister } from '../pages/cow_register/cow_register';
import { CowList } from '../pages/cow_list/cow_list';
import { Cow_Weight } from '../pages/cow_weight/cow_weight';
import { SqliteProvider } from '../providers/sqlite/sqlite';
import { SimPage } from '../pages/sim/sim';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = LoginPage;
  @ViewChild(Nav) nav: Nav;
  constructor(
    platform: Platform, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen, 
    public app: App,
    private data: DataProvider,
    public sqlite: SqliteProvider) {

    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
    });
    this.data.currentTabName = 'Нэвтрэх хэсэг';
    // this.sqlite.initDB();
    if(localStorage.getItem('email') !== null && localStorage.getItem('password') !== null) {
      this.data.userId = JSON.parse(localStorage.getItem('login')).data.user_id;
      this.data.userName = JSON.parse(localStorage.getItem('login')).data.username;
      this.data.phone = JSON.parse(localStorage.getItem('login')).data.phone;
      this.data.email = JSON.parse(localStorage.getItem('login')).data.email;
      this.data.workYearIn = JSON.parse(localStorage.getItem('login')).data.start_date;
      this.data.role = JSON.parse(localStorage.getItem('login')).data.role_name;
      this.data.farm_id = localStorage.getItem('farmId');
      this.data.password = localStorage.getItem('password');
      for(let i = 0; i < JSON.parse(localStorage.getItem('farms')).length; i++) {
        if(JSON.parse(localStorage.getItem('farms'))[i].id == localStorage.getItem('farmId')) {
          this.data.farmName = JSON.parse(localStorage.getItem('farms'))[i].farm_name;
        }
      }
      this.rootPage = HomePage;
    }
  }
  public logout() {
    this.data.userId = null;
    this.data.email = null;
    this.data.phone = null;
    this.data.role = null;
    this.data.userName = null;
    this.data.workYearIn = null;
    localStorage.clear();

    var nav = this.app.getRootNavs();
    nav[0].setRoot(LoginPage);
  }
  public cowAdd(){
    this.nav.push(CowRegister);
  }
  public cowList(){
    this.nav.push(CowList);
  }
  public simulation(){
    this.nav.push(SimPage);
  }
  public cowWeight(){
    this.nav.push(Cow_Weight);
  }
  public back() {
    if(document.getElementById('backFrom').innerText == '') {
      let nav = this.app.getRootNavs();
      // if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
      //   nav[0].setRoot(AdminDashboardPage);
      //   // this.nav.popTo(AdminDashboardPage, {});
      // } else {
        nav[0].setRoot(HomePage);
        // this.nav.popTo(DashboardPage, {});
      // }
    } else {
      this.nav.push(HomePage);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts